<template>
    <div class="row justify-content-center mb-3">
        <div class="mr-3">
            <span id="privacy-modal-btn" class="link " @click="$bvModal.show('privacy-modal')" v-dompurify-html="$t('PRIVACY')"></span>
            <b-modal id="privacy-modal" scrollable centered hide-footer ok-only>
                <template v-slot:modal-title >
                    <div class="modal-heading" v-dompurify-html="$t('PRIVACY')"></div>
                </template>
                <div class="d-block text-center content" v-dompurify-html="$t('PRIVACY_TEXT')"></div>
            </b-modal>
        </div>
        <div class="">
            <span id="general-conditions-modal-btn" class="link " @click="$bvModal.show('general-conditions-modal')" v-dompurify-html="$t('GENERAL_CONDITIONS')"></span>
            <b-modal id="general-conditions-modal" scrollable centered hide-footer ok-only>
                <template v-slot:modal-title>
                    <div class="modal-heading" v-dompurify-html="$t('GENERAL_CONDITIONS')"></div>
                </template>
                <div class="d-block text-center content" v-dompurify-html="$t('GENERAL_CONDITIONS_TEXT')"></div>
            </b-modal>
        </div>
        <div class="ml-3">
            <span id="about-us-modal-btn" class="link" @click="$bvModal.show('about-us-modal')" v-dompurify-html="$t('ABOUT_US')"></span>
            <b-modal id="about-us-modal" hide-footer scrollable centered ok-only>
                <template v-slot:modal-title>
                    <div class="modal-heading" v-dompurify-html="$t('ABOUT_US')"></div>
                </template>
                <div class="d-block text-center content" v-dompurify-html="$t('ABOUT_US_TEXT')"></div>
            </b-modal>
        </div>
         <div class="ml-3">
            <a href="mailto:jan.degryse@kuleuven.be" id="feedback-btn" target="_top">{{ $t('FEEDBACK_BUTTON') }}</a>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.link {
    cursor: pointer;
    color:#39566e;
    text-decoration: none;
}
.link:hover {
    text-decoration: underline;
}
.modal-heading {
    font-size: 1.5rem;
    font-weight: bold;
}
.content {
    font-size: 0.8rem;
} 
</style>